module.exports = __webpack_public_path__ + "img/1f9a1.452e1eb.svg";